export enum TransactionSource {
  ERP = "ERP",
  LK = "ЛК",
  LKP = "ЛКП",
}
